import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { Icon, Select, Dropdown, Menu } from "antd";
import moment from "moment";

import { requests, requests_label } from "../../../configs/constants";
const RequestsModal = ({ requests: requestsList = [] }) => {
  const [selectedUser, setSelectedUser] = useState();
  const [selectedType, setSelectedType] = useState();

  const Request = ({ request }) => {
    const data = request.data || {};
    const infos = request.infos || {};
    switch (request.type) {
      case requests.PDC_UPDATE:
        const nbModifications = Object.keys(data).length - 1;
        return (
          <Link
            to={{
              pathname: `/basepdc/detail/${infos.pdc_id}`,
              params: { request }
            }}
          >
            <div>
              <Dropdown
                overlay={
                  <Menu>
                    {Object.keys(data).map((key, i) => {
                      if (key === "pdc_id") {
                        return null;
                      }
                      if (typeof data[key] === "object") {
                        return null;
                      }
                      return (
                        <Menu.Item key={i}>
                          {key} : {data[key]}
                        </Menu.Item>
                      );
                    })}
                  </Menu>
                }
              >
                <a className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                  Modification : {infos.pdc_label} ({nbModifications} modification(s))
                </a>
              </Dropdown>
            </div>
            <div style={{ textAlign: "center", marginTop: 10, verticalAlign: "center" }}>
              Visualiser la modification <Icon type="eye" style={{ color: "#000000" }} />
            </div>
          </Link>
        );
      case requests.PDC_CREATION:
        return (
          <Link
            to={{
              pathname: `/basepdc/detail/creation`,
              params: { request }
            }}
          >
            Création d'un pdc : {data.pdc_label}, {data.city} {data.zip_code ? `(${data.zip_code})` : ""}
          </Link>
        );
      case requests.SECTOR_ADD_USER:
        return (
          <Link
            to={{
              pathname: `/basepdc/detail/${infos.pdc_id}`,
              params: { request }
            }}
          >
            Ajout à une sectorisation : {infos.pdc_label}
          </Link>
        );
      default:
        return null;
    }
  };
  const userEmails = [...new Set(requestsList.map(request => request.infos.user_email))].sort();
  const types = [...new Set(requestsList.map(request => request.type))].sort();
  return (
    <Fragment>
      <div className="flex" style={{ width: "100%", justifyContent: "space-around" }}>
        <div style={{ width: "40%" }}>
          <Select placeholder={"Type de réquête"} showSearch onChange={setSelectedType} style={{ width: "100%" }}>
            {types.map(type => {
              return (
                <Select.Option key={type} value={type}>
                  {requests_label[type]}
                </Select.Option>
              );
            })}
          </Select>
        </div>
        <div style={{ width: "40%" }}>
          <Select placeholder={"Utilisateur"} showSearch onChange={setSelectedUser} style={{ width: "100%" }}>
            {userEmails.map(user_email => {
              return (
                <Select.Option key={user_email} value={user_email}>
                  {user_email}
                </Select.Option>
              );
            })}
          </Select>
        </div>
      </div>

      <div>
        {requestsList
          .filter(request => {
            if (selectedUser && request.infos.user_email !== selectedUser) {
              return false;
            }
            if (selectedType && request.type !== selectedType) {
              return false;
            }
            return true;
          })
          .map((request, i) => (
            <div key={request._id || i} style={{ margin: 20, display: "flex", justifyContent: "space-between" }}>
              <span>
                {`${i + 1} -`} <Request request={request} />
              </span>

              <span>{`Soumis par ${request.infos.user_email}`}</span>
              <span>{`le ${moment(request.created_at).format("DD/MM/YYYY")}`}</span>
            </div>
          ))}
      </div>
    </Fragment>
  );
};
export default RequestsModal;



// WEBPACK FOOTER //
// src/containers/metier/pdcs/Requests.modal.js